import React, { useContext, useEffect, useState } from 'react';
import ReactPlayer from 'react-player';
import PropTypes from 'prop-types';
import { Flex, Text } from 'rebass';
import { FaVideoSlash } from 'react-icons/fa';
import { useEntity } from 'entities/hooks';
import { StoryPageContext } from 'story-pages/item/context';

const Player = ({ editing, id }) => {
  const { entity: medium } = useEntity({ id, type: 'audios' });
  const { currentMedia, setCurrentMedia } = useContext(StoryPageContext);
  const [url, setUrl] = useState(null);

  const changeVideo = (newUrl) => {
    setUrl(null);
    setTimeout(() => {

      setUrl(newUrl);
    }, 100);
  };

  useEffect(() => {
    if (medium?.['asset-url'])
      changeVideo(medium?.['asset-url'])
  }, [medium?.['asset-url']])

  if (medium.state === 'pre_uploaded' || (medium.state !== 'finished')) {
    return (
      <Flex
        bg="border"
        width="100%"
        height={[260, 400]}
        alignItems="center"
        justifyContent="center"
        flexDirection="column"
        px={4}
        sx={{ textAlign: 'center' }}
      >
        <Text as={FaVideoSlash} fontSize={96} color="lightText" pb={3} />
        <Text pb={3} color="mutedText">
          This audio clip is being processed
        </Text>
        <Text pb={3} color="mutedText">
          In the meanwhile, feel free to add more to the story
        </Text>
        <Text pb={3} color="mutedText">
          ... or create a new story while you wait &#128516;
        </Text>
      </Flex>
    );
  }

  return (
    <Flex justifyContent="center" >
      <ReactPlayer
        key={url}
        url={url}
        controls
        height={40}
        onPlay={() => setCurrentMedia(id)}
        onPause={() => setCurrentMedia(null)}
        playing={currentMedia === id}
      />
    </Flex>
  );
};

Player.propTypes = {
  id: PropTypes.string.isRequired,
  editing: PropTypes.bool,
};

Player.defaultProps = { editing: false };

export default Player;
